import React, { useState, useEffect } from "react";
import { PsrCaptureProfile } from "../../../../Model/CaptureProfile";
import { Exposure } from "../../../../Model/ImagerCapabilities";
import ImagerFeatureControlSlider from "../../../Imager/ImagerFeatureControlSlider";
import EOpticAndCameraFeature from "../../../../Model/EOpticAndCameraFeature";
import {
  BaseControl,
  FeatureLabel,
  ValueTextBox,
  UnitLabel,
} from "../../../Imager/ImagerFeatureControls";

type ExposureControlProps = {
  captureProfile: PsrCaptureProfile;
  onChange: (value: { exposure: number }) => void;
  disabled: boolean;
  exposure: Exposure;
};

export function PsrExposureControl({
  exposure,
  captureProfile,
  onChange,
  disabled,
}: ExposureControlProps) {
  if (captureProfile.exposure == null) {
    throw new Error("Capture profile exposure is null");
  }

  const [tbValue, setTbValue] = useState(captureProfile.exposure);
  // const halfTick = (exposure.maxExposure - exposure.minExposure) / 2;

  useEffect(() => {
    if (captureProfile.exposure == null) {
      throw new Error("Capture profile exposure is null");
    }
    setTbValue(captureProfile.exposure);
  }, [captureProfile.exposure]);

  return (
    <BaseControl
      key={EOpticAndCameraFeature.Exposure}
      id={EOpticAndCameraFeature.Exposure}
      disabled={disabled}
    >
      <FeatureLabel disabled={disabled}>{"Exposure Time:"}</FeatureLabel>
      <ImagerFeatureControlSlider
        disabled={disabled}
        value={captureProfile.exposure}
        min={exposure.minExposure}
        max={exposure.maxExposure}
        onValueChanged={(value: number) =>
          onChange({
            exposure: value,
          })
        }
        onHandleDraged={(value: number) => setTbValue(value)}
        step={0.1}
        style={{
          marginLeft: 5,
          flexGrow: 1,
        }}
      />
      <ValueTextBox
        min={exposure.minExposure}
        max={exposure.maxExposure}
        disabled={disabled}
        value={tbValue < exposure.minExposure? exposure.minExposure  :tbValue}
        onValueChanged={(id: string, value: number) =>
          onChange({
            exposure: value,
          })
        }
        id={EOpticAndCameraFeature.Exposure}
      />
      <UnitLabel disabled={disabled}>ms</UnitLabel>
    </BaseControl>
  );
}
